module.exports = __webpack_public_path__ + "static/media/All_star_Fishing.a00caf9c.png";